import React from "react";

export default function SimpleError({ error }: { error: string | undefined }) {
  return error ? <div className="text--danger">{error}</div> : null;
}
